import { word } from "@modules/core/utils/i18n"

export function getSlotDurationOptions() {
  return [
    { label: `30 ${word("global.minute.label", { count: 30 })}`, value: 30 }, // minutes
    { label: `45 ${word("global.minute.label", { count: 45 })}`, value: 45 }, // minutes
    { label: `1 ${word("global.hour.label", { count: 1 })}`, value: 60 }, // minutes
    {
      label: `1 ${word("global.hour.label", { count: 1 })} 30${word("global.minute.label", { count: 30 })}`,
      value: 90, // minutes
    },
    { label: `2 ${word("global.hour.label", { count: 2 })}`, value: 120 }, // minutes
    { label: word("box.slotTemplateGroup.form.slotDuration.custom"), value: 0 },
  ]
}
export function getRegistrationBeginningOptions() {
  return [
    {
      label: word("global.minutePrior.label", { count: 30 }),
      value: 30, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 1 }),
      value: 60, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 2 }),
      value: 120, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 4 }),
      value: 240, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 1 }),
      value: 1440, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 2 }),
      value: 2880, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 3 }),
      value: 4320, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 4 }),
      value: 5760, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 5 }),
      value: 7200, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 6 }),
      value: 8640, // minutes
    },
    {
      label: word("global.weekPrior.label", { count: 1 }),
      value: 10080, // minutes
    },
    {
      label: word("global.weekPrior.label", { count: 2 }),
      value: 20160, // minutes
    },
    { label: word("box.slotTemplateGroup.form.slotDuration.custom"), value: 0 },
  ]
}
export function getRegistrationEndOptions() {
  return [
    {
      label: word("global.lastMinutePrior"),
      value: 1, // minutes
    },
    {
      label: word("global.minutePrior.label", { count: 30 }),
      value: 30, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 1 }),
      value: 60, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 2 }),
      value: 120, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 4 }),
      value: 240, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 1 }),
      value: 1440, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 2 }),
      value: 2880, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 3 }),
      value: 4320, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 4 }),
      value: 5760, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 5 }),
      value: 7200, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 6 }),
      value: 8640, // minutes
    },
    {
      label: word("global.weekPrior.label", { count: 1 }),
      value: 10080, // minutes
    },
    {
      label: word("global.weekPrior.label", { count: 2 }),
      value: 20160, // minutes
    },
    { label: word("box.slotTemplateGroup.form.slotDuration.custom"), value: 0 },
  ]
}
export function getCancellationBeginningOptions() {
  return [
    {
      label: word("global.lastMinutePrior"),
      value: 1, // minutes
    },
    {
      label: word("global.minutePrior.label", { count: 30 }),
      value: 30, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 1 }),
      value: 60, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 2 }),
      value: 120, // minutes
    },
    {
      label: word("global.hourPrior.label", { count: 4 }),
      value: 240, // minutes
    },
    {
      label: word("global.dayPrior.label", { count: 1 }),
      value: 1440, // minutes
    },
    { label: word("box.slotTemplateGroup.form.slotDuration.custom"), value: 0 },
  ]
}
